<template>
    <div class="container">
        <button class="btn btn-nav m-2"
                name="close"
                @click="$emit('update:editingTemplate', false)">Close</button>
        <button class="btn btn-cph-primary-outline m-2"
                name="save"
                @click="addTemplate">Save</button>
        <div class="row">
            <div class="col-12">
                <div class="layout-picker mt-4">
                    <label for="templatepicker">Choose templates</label>
                    <multiselect v-model="activeTemplates"
                                 :deselect-label="$t('UI.cantRemove')"
                                 track-by="id"
                                 label="description"
                                 :max-height="600"
                                 :closeOnSelect="false"
                                 :multiple="true"
                                 placeholder="Select templates"
                                 id="templatepicker"
                                 :preserve-search="true"
                                 :options="availableTemplatesByChosenGroups"
                                 :searchable="true"
                                 :allow-empty="true"></multiselect>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ObjectValueContent from './ObjectValueContent.vue';
import ObjectValue from './ObjectValue.vue';
import CssProp from './CssProp/CssProp.vue';
export default {
    name: 'TemplateObject',
    data () {
        return {
            templateIndex: 0,
            availableTemplatesInGroups: [],
            templates: null
        };
    },
    props: {
        editingTemplate: {
            type: Boolean
        }
    },
    watch: {
        activeTemplates (newVal) {
            if(newVal.length === 0) {
                this.$vuexSet(`${this.currentLayoutPath}`, []);
                return;
            }
            const promises = [];
            let readyStyles = [];
            newVal.forEach(el => {
                if(el.storeId) {
                    promises.push(this.getTemplateJSONAsync(el));
                } else {
                    readyStyles.push(el);
                }
            });
            this.$utils.resolvePromises(promises).then(res => {
                let templates = this.$utils.flatten([...res], [...readyStyles]);
                templates.forEach(el => {
                    el.active = true;
                    el.elementId = this.editedElementId;
                });
                this.$vuexSet(`${this.currentLayoutPath}`, templates);
            });
        },
        editedElementId () {
            this.$emit('update:editingTemplate', false);
        }
    },
    computed: {
        ...mapGetters({
            availableTemplates: 'getTemplates',
            editedElementId: 'getEditedElementId',
            rootPath: 'getEditedElementRootPath',
            currentLayout: 'getCurrentLayout',
            templateGroups :'getTemplateGroups',
            editedElement: 'getEditedElement'
        }),
        completePath () {
            return 'templates';
        },
        currentLayoutPath () {
            return 'currentLayout.templates';
        },
        appliedGroupIds () {
            if(this.editedElement.groups && this.editedElement.groups.length > 0) {
                return this.editedElement.groups.map(group => group.id);
            } else {
                return [];
            }
        },
        activeTemplates: {
            get () {
                return this.templates;
            },
            set (newList) {
                newList.forEach(el => el.elementId = this.editedElementId);
                this.templates = newList;
            }
        },
        availableTemplatesByChosenGroups () {
            if(this.availableTemplates.length === 0) {
                return [];
            }
            return this.availableTemplates.filter(
                template => this.availableTemplatesInGroups.indexOf(template.id) > -1
            );
        }
    },
    components: {
        ObjectValueContent,
        ObjectValue,
        CssProp
    },
    methods: {
        ...mapActions([
            'postTemplate',
            'getTemplatesByGroupIds',
            'getTemplateJSONAsync'
        ]),
        ...mapMutations([
            'removeTemplateFromCurrentLayout',
            'addAlert',
            'setAvailableTemplates'
        ]),
        fetchTemplates () {
            if(this.editedElement.groups.length > 0) {
                this.getTemplatesByGroupIds(this.appliedGroupIds).then(res => {
                    this.availableTemplatesInGroups = res;
                });
            }
        },
        addTemplate () {
            this.setAvailableTemplates(this.activeTemplates.map(template =>
                ({id: template.id, elementId: template.elementId}))
            );
            this.$emit('update:editingTemplate', false);
        }
    },
    created () {
        if(this.currentLayout.templates && this.currentLayout.templates.length > 0) {
            this.templates = this.currentLayout.templates.filter(
                tpl => tpl.elementId === this.editedElementId
            );
        } else {
            this.templates = [];
        }
        this.$store.dispatch('getAllTemplatesAsync').then(() => {
            this.fetchTemplates();
        });
    }
};
</script>

<style lang="scss">
    .delete-prop-button {
        position: absolute;
        top: 0;
        right: 0;
    }
    
    .template-name {
        cursor: pointer;
        &:hover {
            color: black;
        }
        
        &.active {
            color: greenyellow;
        }
    }
</style>
